import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/dataflow/devicedetails";

export class PostDataFlowDeviceDetailsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: {};
    params: PostDataFlowDeviceDetailsReqData;

    constructor(installationName: string, converterType: string, deviceDetail: {}) {
        super();
        this.payload = deviceDetail;
        this.params = new PostDataFlowDeviceDetailsReqData(installationName, converterType);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(this.payload, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class PostDataFlowDeviceDetailsReqData {
    installationName: string;
    converterType: string;

    constructor(installationName: string, converterType: string) {
        this.installationName = installationName;
        this.converterType = converterType;
    }
}
